import { PageContent } from '@reapitform/dashboard-ui'
import { elPy9, Table, TTableRowAction } from '@reapitform/common-ui'
import { documentTableConfig } from './document-table-config'
import { IDocumentDefault } from '../../../../api/types'
import { useDefaultsDocument } from '../../../../api/defaults/documents'
import { useState } from 'react'
import { FlexContainer, Loader, ModalBg, TextBase } from '@reapit/elements'
import { AddDocument } from './modal/add-document'
import { DeleteDocument } from './modal/delete-confirmation'
import { useAttachment } from '@reapitform/hooks'
import { useSearchParams } from 'react-router-dom'

export const DocumentTabContent: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState<boolean>(false)
  const [isOpenAddFormModal, setIsOpenAddFormModal] = useState<boolean>(false)
  const [selectedData, setSelectedData] = useState<IDocumentDefault>()
  const { downloadFile, isLoading: isDownloading } = useAttachment({
    errorMessage: 'Failed to download the document',
    successMessage: 'Document successfully downloaded',
  })

  const { data, loading, errorString, updateCacheData } = useDefaultsDocument({
    sortBy: searchParams.get('sortBy'),
    sortByDirection: searchParams.get('sortByDirection'),
  })

  const handleSortChanges = (key: string, order: 'asc' | 'desc') => {
    setSearchParams((params) => {
      params.set('sortBy', key)
      params.set('sortByDirection', order === 'asc' ? 'Ascending' : 'Descending')
      return params
    })
  }

  const rowActions: TTableRowAction<IDocumentDefault>[] = [
    {
      actionTitle: 'Download',
      onClick: (data) => downloadFile(data.defaultAttachmentFileID),
    },
    {
      actionTitle: 'Delete',
      onClick: (data) => {
        setSelectedData(data)
        setIsOpenDeleteConfirmation(true)
      },
    },
  ]

  return (
    <PageContent className={elPy9}>
      <FlexContainer isFlexColumn>
        <TextBase hasSectionMargin>{documentTableConfig.description}</TextBase>
        <Table
          headers={documentTableConfig.header}
          rows={data}
          isLoading={loading}
          rowKeyIdentifier="id"
          errorMessage={errorString}
          emptyMessage={documentTableConfig.emptyMessages}
          tableDataCountMessage={documentTableConfig.countDisplay}
          onReorder={handleSortChanges}
          tableRowAction={rowActions}
          tableAction={{
            actionTitle: 'Upload New',
            onClick: () => setIsOpenAddFormModal(true),
          }}
        />
      </FlexContainer>
      <AddDocument
        isOpen={isOpenAddFormModal}
        onOpenChange={(isOpen) => setIsOpenAddFormModal(isOpen)}
        refreshList={updateCacheData}
      />
      <DeleteDocument
        data={selectedData}
        isOpen={isOpenDeleteConfirmation}
        onOpenChange={(isOpen) => setIsOpenDeleteConfirmation(isOpen)}
        refreshList={updateCacheData}
      />
      {isDownloading && (
        <>
          <ModalBg className="el-is-active" />
          <Loader fullPage label="downloading ..." />
        </>
      )}
    </PageContent>
  )
}
